module.exports = __webpack_public_path__ + "img/plane.9ee4132e.png";